<template>
    <nav class="app-nav navbar navbar-expand-md navbar-light sticky-top">
        <div class="container-fluid">
            <div v-if="!hasSidebar" class="navbar-brand">
                <inertia-link href="/"><img :src="theme_logo" class="logo" alt=""></inertia-link>
            </div>

            <div v-if="!hasSidebar && mainPage !== ''">
                <inertia-link class="btn btn-light" :href="`/app/${mainPage}`">{{ mainPage === 'learning-path' ? 'View all learning paths' : ( mainPage === 'project' ? 'View all projects' : '' ) }}</inertia-link>
            </div>

            <button v-if="hasSidebar"
                    class="btn btn-light d-flex align-items-center hamburger"
                    type="button"
                    @click="sidebar_collapse_toggle()">
                <img src="/images/icons/bars.svg" alt="">
            </button>

            <button v-if="toolbox.collapsed"
                    class="btn btn-light d-flex align-items-center"
                    type="button"
                    @click="toolbox_collapse_set(false)">
                <img src="/images/icons/toolbox.svg" alt="">
            </button>

            <div class="collapse navbar-collapse">

                <!-- Left Side Of Navbar -->
                <div :class="hasSidebar ? '' : 'center-width'" class="navbar-nav ml-md-3 nav-left" id="app-nav-left">
                    <slot name="navbar-left"/>
                </div>

<!--                <ul class="navbar-nav mr-auto nav-left">-->

<!--&lt;!&ndash;                    <jet-nav-link :href="route('warmups')" :active="route().current('warmups')">&ndash;&gt;-->
<!--&lt;!&ndash;                        Warmups&ndash;&gt;-->
<!--&lt;!&ndash;                    </jet-nav-link>&ndash;&gt;-->

<!--                    <jet-nav-link :href="route('project.dashboard')" :active="route().current('project.*')">-->
<!--                        Change Projects-->
<!--                    </jet-nav-link>-->

<!--                    <jet-nav-link :href="route('resources')" :active="route().current('resources')">-->
<!--                        Resources-->
<!--                    </jet-nav-link>-->

<!--                    <jet-nav-link :href="route('development')" :active="route().current('development')">-->
<!--                        Professional Development-->
<!--                    </jet-nav-link>-->
<!--                </ul>-->

                <ul class="navbar-nav ml-auto nav-right align-items-center">
                    <!-- Authentication Links -->
                    <jet-dropdown id="notificationDropdown" class="mr-2">
                        <template #trigger>
                            <img src="/images/icons/bell.svg" alt="">
                        </template>

                        <template #content>
                            <div class="p-3">
                                Notifications...
                            </div>
                        </template>
                    </jet-dropdown>


                    <!-- Authentication Links -->
                    <jet-dropdown id="settingsDropdown">
                        <template #trigger>
                            <img v-if="$page.props.jetstream.managesProfilePhotos" class="rounded-circle" width="32" height="32" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" />
                            <span v-else>
                                <img class="rounded-circle" width="32" height="32" src="https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png"/>
                                {{ is_impersonating ? 'Impersonating' : 'Howdy' }}, {{ $page.props.user.name }}
                                <svg class="ml-2" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </span>
                        </template>

                        <template #content>
                            <!-- Account Management -->
                            <h6 class="dropdown-header small text-muted">
                                Manage Account
                            </h6>

                            <jet-dropdown-link :href="route('profile.edit', {...global_url_params})" class="font-weight-semi-bold d-flex align-items-center">
                                <img class="mr-2" src="/images/icons/user-cog.svg" alt=""> Profile
                            </jet-dropdown-link>

                            <jet-dropdown-link as="button"
                                               @click.prevent.stop="showInvitation()"
                                               class="font-weight-semi-bold d-flex align-items-center">
                                <img class="mr-2" src="/images/icons/share-secondary.svg" alt=""> Invite User
                            </jet-dropdown-link>

                            <jet-dropdown-link :href="route('api-tokens.index')" v-if="$page.props.jetstream.hasApiFeatures">
                                API Tokens
                            </jet-dropdown-link>

                            <hr class="dropdown-divider">

                            <!-- Authentication -->

                            <template v-if="is_impersonating">
                                <jet-dropdown-link :href="route('auth.impersonate.revert', {...global_url_params})"
                                                   class="font-weight-semi-bold text-secondary d-flex align-items-center"
                                                   method="post">
                                    <img class="mr-2" src="/images/icons/logout-secondary.svg" alt=""> Revert
                                </jet-dropdown-link>
                                <hr class="dropdown-divider">
                            </template>

                            <form @submit.prevent="logout">
                                <jet-dropdown-link as="button" class="font-weight-semi-bold text-secondary d-flex align-items-center">
                                    <img class="mr-2" src="/images/icons/logout-secondary.svg" alt=""> Logout
                                </jet-dropdown-link>
                            </form>


                        </template>
                    </jet-dropdown>
                </ul>

            </div>

        </div>

        <invitation-modal v-if="invitation.show"
                          @close="closeInvitation()"/>

    </nav>
</template>

<script>

import JetNavLink from "@/Jetstream/NavLink";
import JetDropdown from "@/Jetstream/Dropdown";
import JetDropdownLink from "@/Jetstream/DropdownLink";
import InvitationModal from "@/Components/Common/InvitationModal";
import {mapMutations, mapState} from "vuex";

export default {
    name: "AppNav",
    components: {JetDropdown, JetDropdownLink, JetNavLink, InvitationModal},
    props: {
        hasSidebar: {
            type: Boolean,
            default: true,
        },
        mainPage: {
            type: String,
            default: ""
        }
    },

    data(){
        return {
            invitation: {
                show: false,
            }
        };
    },

    computed: {
        ...mapState(['toolbox'])
    },

    methods:{
        ...mapMutations(['sidebar_collapse_toggle', 'toolbox_collapse_set']),

        showInvitation(){
            this.invitation.show = true;
        },

        closeInvitation(){
            this.invitation.show = false;
        },

        logout() {
            this.$inertia.post(route('logout', {...this.global_url_params}));
        },

    }
}
</script>

<style lang="scss" scoped>
.app-nav{
    position: sticky;
    top: 0;
    z-index: 9999 + 50;
    margin-bottom: 0.6rem;
    padding: 0.4rem 0;
}

.center-width{
    width: 83%;
}

@media (min-width: 650px) and (max-width: 1199px){
    .hamburger{
        display: none !important;
    }

}
</style>
